<template>
    <div class="block-editor google-drive-upload-file">
        <section>
            <div class="title">{{ $t('auto.googleDriveUploadFileChannelId') }}</div>
            <TiptapEditor placeholder="Google Drive Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.googleDriveUploadFileDosyanNYKleneceIGoogleDriveKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleDriveUploadFileAssetId') }}</div>
            <TiptapEditor placeholder="Supsis Asset ID" :show-attributes="true" v-model="clone.assetId" automation-mode />
            <small>{{ $t('auto.googleDriveUploadFileYKlenecekDosyanNSupsisAssetIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleDriveUploadFileFolderIdOpsiyonel') }}</div>
            <TiptapEditor placeholder="Google Drive Folder ID" :show-attributes="true" v-model="clone.folderId" automation-mode />
            <small>{{ $t('auto.googleDriveUploadFileDosyanNYKleneceIKlasRIdsiBoBRakLRsaRootaYKlenir') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleDriveUploadFileDosyaAdOpsiyonel') }}</div>
            <TiptapEditor placeholder="Yeni dosya adı" :show-attributes="true" v-model="clone.fileName" automation-mode />
            <small>{{ $t('auto.googleDriveUploadFileDosyaIInZelBirAdBoBRakLRsaOrijinalAdKullanLR') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleDriveUploadFile",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                assetId: "",
                folderId: "",
                fileName: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-drive-upload-file {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
